import React from 'react';
import { addLeadingZero } from './../../utils/helper';
import CircularProgress from '../../ui/CircularProgress';
import './../style/fonts.module.css'

const Sidebar = ({questions, activeQuestion, quizDetails: { totalQuestions, totalTime }, timer,}) => {
  return (
    <div className="sticky top-0 hidden h-dvh flex-col gap-12 overflow-hidden bg-white p-6 backdrop-blur-sm [mask:linear-gradient(black,black,black,transparent)] lg:flex">
      

      <CircularProgress
        content={`${addLeadingZero(activeQuestion + 1)}/${addLeadingZero(totalQuestions)}`}
      />

      <ol start={activeQuestion + 1} className="space-y-2 px-4">
        {questions
          .filter((_, index) => index >= activeQuestion)
          .map(({ libelle }, /* { question },  */index) => (
            <li
              key={index}
              className={`${index === 0 ? 'text-[#fe843d]' : ''} list-decimal pl-1 text-base`}
            >
              {libelle}{/* {question} */}
            </li>
          ))}
      </ol>
    </div>
  );
};

export default Sidebar;